import { QueueItemCard } from './QueueItemCard';
import type { UploadQueueItem } from '../types';

export interface FileQueueGridProps {
  items: UploadQueueItem[];
  onRemove: (id: string) => void;
  onRetry: (id: string) => void;
}

export function FileQueueGrid({ items, onRemove, onRetry }: FileQueueGridProps) {
  if (items.length === 0) return null;

  return (
    <div
      data-testid="file-queue-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
        gap: 12,
        width: '100%',
      }}
    >
      {items.map((item) => (
        <QueueItemCard key={item.id} item={item} onRemove={onRemove} onRetry={onRetry} />
      ))}
    </div>
  );
}
